export default "__VITE_ASSET__6Qiidx85bktMy9U258qX3w__"